import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import AudioRecorder from "../components/AudioRecorder";
import EditableSummaryField from "./EditableSummaryField";
import PatientActionEditor from "./PatientActionsEditor";
import EditableActionField from "./EditableActionField";
import ClinicianActionEditor from "./ClinicianActionEditor";
import { getTranscriptsByAppointmentId } from "./../api";
import DashboardTabs from "../components/DashboardTabs.js";

import "./transcriptStyle.css"; // Import the CSS file for styling

const tabs = ["Notes", "Action Items", "ICD-10", "Patient Summary"];

function VisitReviewPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Notes");
  const [activeSection, setActiveSection] = useState("subjective");
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [checked, setChecked] = useState({ accuracy: false, match: false });
  const [submitting, setSubmitting] = useState(false);
  const [approved, setApproved] = useState(false);
  const [documentId, setDocumentId] = useState("");

  const [appointment, setAppointment] = useState(location.state?.appointment);

  const [transcripts, setTranscripts] = useState([]);

  const [selectedtranscript, setSelectedtranscript] = useState({});

  const [uniqueTranscriptCodes, setUniqueTranscriptCodes] = useState(null);

  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");
  const [text, setText] = useState("");
  const [category, setCategory] = useState("");

  const [selectedtranscriptjson, setSelectedtranscriptjson] = useState({
    summaryMap: {
      CHIEF_COMPLAINT: "",
      HISTORY_OF_PRESENT_ILLNESS: "",
      REVIEW_OF_SYSTEMS: "",
      PAST_MEDICAL_HISTORY: "",
      PAST_FAMILY_HISTORY: "",
      PAST_SOCIAL_HISTORY: "",
      PHYSICAL_EXAMINATION: "",
      DIAGNOSTIC_TESTING: "",
      ASSESSMENT: "",
      PLAN: "",
    },
    interactions: [],
    actions: {
      summary: "",
      patient_actions: [],
      clinician_actions: [],
    },
    entities: [],
  });

  const emptyTranscriptJson = {
    summaryMap: {
      CHIEF_COMPLAINT: "",
      HISTORY_OF_PRESENT_ILLNESS: "",
      REVIEW_OF_SYSTEMS: "",
      PAST_MEDICAL_HISTORY: "",
      PAST_FAMILY_HISTORY: "",
      PAST_SOCIAL_HISTORY: "",
      PHYSICAL_EXAMINATION: "",
      DIAGNOSTIC_TESTING: "",
      ASSESSMENT: "",
      PLAN: "",
    },
    interactions: [],
    actions: {
      summary: "",
      patient_actions: [],
      clinician_actions: [],
    },
    entities: [],
  };

  useEffect(() => {
    console.log(appointment);

    getTranscriptsByAppointmentId(appointment.appointment_id)
      .then((response) => {
        console.log(response);
        setTranscripts(response);

        if (response.length > 0) {
          const sel = response[0]

          setSelectedtranscript(sel);
          if (sel.transcript) {
            let transcriptJson = JSON.parse(sel.transcript);
            setSelectedtranscriptjson(transcriptJson);
            console.log("Selected transcript:", transcriptJson);
            const codes = getUniqueICD10Codes(transcriptJson);
            setUniqueTranscriptCodes(codes);
            console.log(codes);
          } else {
            setSelectedtranscriptjson({ ...emptyTranscriptJson });
          }
        }


      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => { });
  }, [appointment]);

  const noteContent = {
    subjective: {
      title: "Subjective",
      body: "Patient reports fatigue, mild appetite fluctuation, and improved sleep pattern after modifying nightly routine.",
    },
    assessment: {
      title: "Assessment",
      body: "Symptoms consistent with mild functional decline, with no acute distress noted during the encounter.",
    },
    plan: {
      title: "Plan",
      body: "Continue supportive measures, reassess in 2 weeks, and escalate if symptoms worsen or new concerns arise.",
    },
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${month}-${day}-${year} ${hours}:${minutes}`;
  };

  const selectTranscript = (event) => {
    setUniqueTranscriptCodes(null);
    const transcriptId = event.target.value;

    console.log("Selected transcript ID:", transcriptId);

    const sel = transcripts.find(
      (transcript) => transcript.id.toString() === transcriptId,
    );

    setSelectedtranscript(sel);
    if (sel.transcript) {
      let transcriptJson = JSON.parse(sel.transcript);
      setSelectedtranscriptjson(transcriptJson);
      console.log("Selected transcript:", transcriptJson);
      // const codes = getUniqueICD10Codes(transcriptJson);
      // setUniqueTranscriptCodes(codes);
      //console.log(codes);
    } else {
      setSelectedtranscriptjson({ ...emptyTranscriptJson });
    }
  };

  const getUniqueICD10Codes = (data) => {
    const uniqueCodes = new Map();

    (data?.entities ?? []).forEach((entity) => {
      (entity?.icd10cm ?? []).forEach((item) => {
        if (item?.code && !uniqueCodes.has(item.code)) {
          uniqueCodes.set(item.code, {
            code: item.code,
            description: item.description,
          });
        }
      });
    });

    return Array.from(uniqueCodes.values()).sort((a, b) =>
      a.code.localeCompare(b.code, undefined, {
        numeric: true,
        sensitivity: "base",
      }),
    );
  };

  const handleRecordingComplete = (audioBlob) => {
    console.log("Audio received from AudioRecorder");
    console.log(audioBlob);
    getTranscriptsByAppointmentId(appointment.appointment_id)
      .then((response) => {
        console.log(response);
        setTranscripts(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => { });
    // Call your API or update state here
  };

  const handleAssessmentChange = (e) => {
    const value = e.target.value;

    setSelectedtranscriptjson((prev) => ({
      ...prev,
      summaryMap: {
        ...prev.summaryMap,
        ASSESSMENT: value,
      },
    }));
  };

  const saveTranscriptChanges = () => {
    console.log(selectedtranscriptjson);
  };

  const handleSaveCode = () => {
    const trimmedCode = code.trim();
    const trimmedDescription = description.trim();
    const trimmedText = text.trim();
    const trimmedCategory = category.trim();

    if (!trimmedCode || !trimmedDescription) return;


    setCode("");
    setDescription("");
    setText("");
    setCategory("");
    setRefreshCodes(refreshCodes + 1);
  };

  const [refreshCodes, setRefreshCodes] = useState(0);

  useEffect(() => {
    const codes = getUniqueICD10Codes(selectedtranscriptjson);
    setUniqueTranscriptCodes(codes);
  }, [refreshCodes]);


  const handleTranscriptChange = (index, icdIndex, field, value) => {

    let updatedTranscriptJson = { ...selectedtranscriptjson };

    updatedTranscriptJson.entities = updatedTranscriptJson.entities.map((item, i) =>
      i === index ? {
        ...item,
        icd10cm: item.icd10cm.map((icd, j) =>
          j === icdIndex
            ? { ...icd, [field]: value }
            : icd
        ),
      }
        : item
    );

    // console.log("Updated transcript JSON:", updatedTranscriptJson.entities);
    setSelectedtranscriptjson(updatedTranscriptJson);

    // setSelectedtranscriptjson((prev) =>
    //   prev.entities.map((item, i) =>
    //     i === index
    //       ? {
    //           ...item,
    //           icd10cm: item.icd10cm.map((icd, j) =>
    //             j === icdIndex
    //               ? { ...icd, [field]: value }
    //               : icd
    //           ),
    //         }
    //       : item
    //   )
    // );
  };

  return (
    <div className="container" >
      {/* <DashboardTabs  name={'visits'} /> */}
      <div className="">
        {/* <div className="wf-bar">
          <div>
            <button
              type="button"
              className="back-button btn-link"
              onClick={() => navigate("/doctor-dashboard")}
            >
              Queue
            </button>
          </div>

          <div className="review-actions">
            <button
              className="btn btn-success btn-sm"
              onClick={() => setShowApprovalModal(true)}
            >
              ✓ Approve &amp; Send to EHR
            </button>
            <button className="btn btn-danger btn-sm">✗ Reject / Redo</button>
          </div>
        </div> */}

        <div
          className="review-grid my-2"
          style={{ minHeight: "80px", gridTemplateColumns: "none" }}
        >
          <div className="panel-card" style={{ height: "80px" }}>
            <div>
              <div className="row">
                <div className="col-lg-6">
                  <select
                    className="form-select"
                    onChange={(event) => {
                      selectTranscript(event);
                    }}
                  >
                    {transcripts &&
                      transcripts.map((transcript) => (
                        <option value={transcript.id}>
                          {formatDateTime(transcript.recorded_at)}-
                          {transcript.transcript_status}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-lg-6">
                  <AudioRecorder
                    onRecordingComplete={handleRecordingComplete}
                    appointmentId={appointment?.appointment_id}
                  />
                </div>
              </div>
            </div>{" "}
          </div>
        </div>

        <div className="review-grid">
          <div className="panel-card">
            <div className="flex-between">
              <div>
                <div className="panel-header">📜 Transcript </div>
              </div>
            </div>




            <div
              className="transcript-list"
              style={{ overflow: "auto", height: "500px" }}
            >
              {selectedtranscriptjson &&
                selectedtranscriptjson.interactions &&
                selectedtranscriptjson.interactions.map((line) => (
                  <div
                  // key={line.id}
                  // className={`transcript-row ${activeSection === line.id ? 'active' : ''} clickable`}
                  // onClick={() => setActiveSection(line.id)}
                  >



                    <div className={line?.split(":")[0]?.replace("_0", "") === "PATIENT" ? "message received" : "message sent"}>
                      <div className="bubble">
                        {line?.split(":")[1]}
                      </div>
                    </div>

                    {/* <div class="message sent">
                      <div class="bubble">
                        I'm good. Thanks!
                      </div>
                    </div> */}





                    {/* <div className="transcript-bars">
                      <div className="speaker-label">
                        {line?.split(":")[0]?.replace("_0", "")}&nbsp;
                      </div>
                     
                      {line}


                      asdfasdfasdfasdfasdf
                    </div> */}
                  </div>
                ))}
            </div>
          </div>

          <div className="panel-card">
            <div className="row ">
             <div className="col-lg-10">

              
            <div className="tabs">
              
 {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
              </div>
             </div>
              <div className="col-lg-2" >
 <button
                className="tab-btn"
                onClick={() => {
                  saveTranscriptChanges();
                }}  style={{backgroundColor: '#0b5ed7', color: 'white', float: 'right',width: '150px'}}
              >
                Apply Changes
              </button>
              </div>
             
            </div>

            {activeTab === "Notes" ? (
              <div className="soap-body">
                <div className="soap-section">
                  <div className="section-label-small">ASSESSMENT</div>
                  <p>
                    {/* <textarea
                      value={
                        selectedtranscriptjson?.summaryMap?.ASSESSMENT || ""
                      }
                      onChange={handleAssessmentChange}
                      rows={6}
                      className="assessment-textarea"
                    /> */}

                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="ASSESSMENT"
                      label="Assessment"
                    />
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">PLAN</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.PLAN} */}
                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="PLAN"
                      label="Plan"
                    />
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">CHIEF COMPLAINT</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.PLAN} */}
                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="CHIEF_COMPLAINT"
                      label="CHIEF_COMPLAINT"
                    />
                  </p>
                </div>


                <div className="soap-section">
                  <div className="section-label-small">Review</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.REVIEW_OF_SYSTEMS} */}
                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="REVIEW_OF_SYSTEMS"
                      label="REVIEW_OF_SYSTEMS"
                    />
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">
                    PHYSICAL EXAMINATION
                  </div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.PHYSICAL_EXAMINATION} */}

                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="PHYSICAL_EXAMINATION"
                      label="PHYSICAL_EXAMINATION"
                    />
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">DIAGNOSTIC TESTING</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.DIAGNOSTIC_TESTING} */}

                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="DIAGNOSTIC_TESTING"
                      label="DIAGNOSTIC_TESTING"
                    />
                  </p>
                </div>

                {/* <div className="info-note">
                  ✏ Click any section to edit inline
                </div> */}
              </div>
            ) : activeTab === "Action Items" ? (
              <div className="soap-body">
                <div className="soap-section">
                  <div className="section-label-small">SUMMARY</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.actions?.summary} */}

                    <EditableActionField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="summary"
                      label="SUMMARY"
                      rows={5}
                    />
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">patient actions</div>
                  <p>
                    {selectedtranscriptjson?.actions?.patient_actions && (
                      <PatientActionEditor
                        actions={selectedtranscriptjson.actions.patient_actions}
                        onChange={(updatedActions) => {
                          setSelectedtranscriptjson((prev) => ({
                            ...prev,
                            actions: {
                              ...prev.actions,
                              patient_actions: updatedActions,
                            },

                          }));
                        }}
                      />
                    )}



                    {/* <EditableActionField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="patient_actions"
                      label="PATIENT ACTIONS"
                      rows={7}
                    /> */}
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">clinician_actions</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.actions?.clinician_actions} */}

                    {selectedtranscriptjson?.actions?.clinician_actions && (
                      <ClinicianActionEditor
                        actions={selectedtranscriptjson.actions.clinician_actions}
                        onChange={(updatedActions) => {
                          setSelectedtranscriptjson((prev) => ({
                            ...prev,
                            actions: {
                              ...prev.actions,
                              clinician_actions: updatedActions,
                            },
                          }));
                        }}
                      />
                    )}


                    {/* <EditableActionField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="clinician_actions"
                      label="CLINICIAN ACTIONS"
                      rows={7}
                    /> */}
                  </p>
                </div>
              </div>
            ) : activeTab === "ICD-10" ? (
              <div className="soap-body">
                <div style={{ height: "500px", overflow: "auto" }}>



                  <ul className="panel-header" style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                    {selectedtranscriptjson?.entities?.map((item, index) => (
                      <li key={index} className="mb-2">
                        {item?.text} -{" "} {item?.category}
                        <div>
                          {item?.icd10cm?.map((icd, icdIndex) => (
                            <div key={icdIndex} className="d-flex align-items-center gap-2">
                              <input
                                className="form-control form-control-sm"
                                style={{ width: "150px", padding: "2px 4px", borderRadius: "0px" }}
                                value={icd?.code || ""}
                                onChange={(e) => handleTranscriptChange(index, icdIndex, "code", e.target.value)}
                              />
                              <input
                                className="form-control form-control-sm"
                                style={{ padding: "2px 4px", borderRadius: "0px" }}
                                value={icd?.description || ""}
                                onChange={(e) => handleTranscriptChange(index, icdIndex, "description", e.target.value)}
                              />
                            </div>
                          ))}
                        </div>

                      </li>
                    ))}
                  </ul>


                  {/* <ul>
                    {uniqueTranscriptCodes?.map(({ code, description }) => (
                      <li key={code}>
                        <strong>{code}</strong> — {description}
                      </li>
                    ))}
                  </ul> */}
                </div>

                <div className="card mt-3 b-0" >
                  <div className="card-header">
                    <h5 className="card-title mb-0 b-0" style={{ color: "#0f4c81" }}>Add ICD-10 Code</h5>
                  </div>
                  <div className="card-body">

                    <div className="d-flex align-items-end gap-2">

                      <div style={{ width: "150px" }}>
                        <label className="form-label mb-1">Symptoms </label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                        />
                      </div>

                      <div className="flex-grow-1">
                        <label className="form-label mb-1">Category</label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                        />
                      </div>
                    </div>


                    <div className="d-flex align-items-end gap-2">

                      <div style={{ width: "150px" }}>
                        <label className="form-label mb-1">Code</label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          value={code}
                          onChange={(e) => setCode(e.target.value)}
                        />
                      </div>

                      <div className="flex-grow-1">
                        <label className="form-label mb-1">Description</label>
                        <input
                          className="form-control form-control-sm"
                          type="text"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-success"
                        onClick={handleSaveCode}
                      >
                        Save Code
                      </button>
                    </div>


                  </div>

                </div>



              </div>
            ) : (
              <div className="soap-body">
                <div className="soap-section">
                  <div className="section-label-small">HISTORY_OF_PRESENT_ILLNESS</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.PLAN} */}
                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="HISTORY_OF_PRESENT_ILLNESS"
                      label="HISTORY_OF_PRESENT_ILLNESS"
                    />
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">PAST_MEDICAL_HISTORY</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.PLAN} */}
                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="PAST_MEDICAL_HISTORY"
                      label="PAST_MEDICAL_HISTORY"
                    />
                  </p>
                </div>
                <div className="soap-section">
                  <div className="section-label-small">PAST_SOCIAL_HISTORY</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.PLAN} */}
                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="PAST_SOCIAL_HISTORY"
                      label="PAST_SOCIAL_HISTORY"
                    />
                  </p>
                </div>

                <div className="soap-section">
                  <div className="section-label-small">PAST_FAMILY_HISTORY</div>
                  <p>
                    {/* {selectedtranscriptjson &&
                      selectedtranscriptjson?.summaryMap?.PLAN} */}
                    <EditableSummaryField
                      selectedtranscriptjson={selectedtranscriptjson}
                      setSelectedTranscriptJson={setSelectedtranscriptjson}
                      field="PAST_FAMILY_HISTORY"
                      label="PAST_FAMILY_HISTORY"
                    />
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showApprovalModal && (
        <div className="modal-backdrop" role="dialog" aria-modal="true">
          <div className="modal-card">
            <div className="modal-header">
              <div>
                <h4>Approval Confirmation</h4>
                <p className="text-muted modal-description">
                  Review and verify before sending to EHR.
                </p>
              </div>
              <button
                className="modal-close"
                onClick={() => setShowApprovalModal(false)}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <p className="text-muted mb-2">
                Patient: <strong>John D.</strong>
              </p>
              <p className="text-muted mb-2">
                Visit: <strong>2024-07-21 10:30 AM</strong>
              </p>
              <p className="text-muted mb-3">
                Provider NPI: <strong>1234567890</strong>
              </p>

              <p className="text-muted mb-2">Outputs being sent:</p>
              <ul className="detail-list mb-3">
                <li>Notes</li>
                <li>Action items</li>
                <li>ICD-10 codes</li>
                <li>Patient summary</li>
              </ul>

              {!approved ? (
                <>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="accuracy"
                      checked={checked.accuracy}
                      onChange={() =>
                        setChecked((prev) => ({
                          ...prev,
                          accuracy: !prev.accuracy,
                        }))
                      }
                    />
                    <label className="form-check-label" htmlFor="accuracy">
                      I have reviewed and verified the accuracy of these notes.
                    </label>
                  </div>

                  <div className="form-check mb-4">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="match"
                      checked={checked.match}
                      onChange={() =>
                        setChecked((prev) => ({ ...prev, match: !prev.match }))
                      }
                    />
                    <label className="form-check-label" htmlFor="match">
                      I confirm this matches the patient visit I conducted.
                    </label>
                  </div>
                </>
              ) : null}
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-outline-secondary"
                onClick={() => setShowApprovalModal(false)}
              >
                Cancel
              </button>
              {!approved ? (
                <button
                  className="btn btn-success"
                  disabled={!checked.accuracy || !checked.match || submitting}
                  onClick={() => {
                    setSubmitting(true);
                    setTimeout(() => {
                      setSubmitting(false);
                      setApproved(true);
                      setDocumentId(
                        `FHIR-${Math.floor(100000 + Math.random() * 900000)}`,
                      );
                    }, 1200);
                  }}
                >
                  {submitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Sending...
                    </>
                  ) : (
                    "Submit Approval"
                  )}
                </button>
              ) : (
                <div className="success-box mb-0">
                  <strong>Success.</strong> FHIR Document ID:{" "}
                  <strong>{documentId}</strong>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VisitReviewPage;
